import AiBotIntentDecisionsAPI from 'dashboard/api/aiBot/intentDecisions';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_RECORDS: 'SET_RECORDS',
  SET_META: 'SET_META',
  UPDATE_RECORD: 'UPDATE_RECORD',
};

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId, ...filters }) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotIntentDecisionsAPI(botId).get(filters);
      commit(types.SET_RECORDS, response.data.payload);
      commit(types.SET_META, response.data.meta);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  stats: async (_context, { botId, from, to }) => {
    try {
      const response = await new AiBotIntentDecisionsAPI(botId).stats({
        from,
        to,
      });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },

  feedback: async ({ commit }, { botId, id, ...feedback }) => {
    try {
      const response = await new AiBotIntentDecisionsAPI(botId).feedback(
        id,
        feedback
      );
      commit(types.UPDATE_RECORD, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_RECORDS]($state, records) {
    $state.records = records;
  },
  [types.SET_META]($state, meta) {
    $state.meta = meta;
  },
  [types.UPDATE_RECORD]($state, record) {
    $state.records = $state.records.map(item =>
      item.id === record.id ? record : item
    );
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
